<template>
    <Paper class="express finance-detail">
        <div class="contents">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <el-button type="primary" :disabled="isConfirm" @click="confirm" v-has="'07010002'">提交确认</el-button>
                <el-button type="primary" :disabled="isRecall" @click="withdraw" v-has="'07010008'" :loading="recallLoading">撤 回</el-button>
            </div>
            <div class="base-line"></div>
            <div class="head-content">
                <div class="head-title">
                    <div class="head-t">
                        <h3 class="head-h3">任务编号：{{this.$route.query.feeTaskCode}}</h3>
                        <span class="head-r">{{status}}</span>
                    </div>
                    <el-button class="head-btn" @click="isShow = !isShow">{{this.isShow ? '收起' : '展开'}}</el-button>
                </div>
                <el-collapse-transition>
                    <div v-show="isShow" class="head">
                        <ElRow :infoData="infoData"></ElRow>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="details-title">
                <div class="left">
                    <span class="bill-details">任务明细</span>
                    <el-button v-has="'07010003'" :disabled="isConfirm" class="upload" type="primary" @click="saveDetails" >保 存</el-button>
                    <el-button v-has="'07010004'" :disabled="isConfirm" class="upload" type="primary" @click="saveAllDetails">批量确认费用</el-button>
                    <el-upload class="upload" :disabled="isDisabled" action
                    :show-file-list="false" :before-upload="beforeUpload" :on-success="afterUpload" :http-request="submitUpload">
                        <el-button v-has="'07010005'" :disabled="isDisabled" type="primary">核对费用导入</el-button>
                    </el-upload>
                </div>
                <div class="right">
                    <el-button v-has="'07010007'" type="text" icon="el-icon-download" @click="exportFeeDetail">导出费用明细</el-button>
                </div>
            </div>
            <template class="table-head">
                <el-table @current-change="handleCurrentChange" highlight-current-row v-loading="loading" :data="tableDataLists" border height="200" style="width: 100%" ref="dragTable">
                    <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in tableDataItems" :key="index" align="center">
                        <template slot-scope="scope">
                            <span class="center">
                                <el-input :class="{red: scope.row.hasValue}" clearable @input="proving(scope.$index)"
                                @change="inputChange(scope.row)" v-if="item.prop==='supplierAmount'&&scope.row.editing === 'arrive'"
                                v-model="scope.row[item.prop]"></el-input>
                                <el-input clearable maxlength="50" v-else-if="item.prop==='supplierMsg'&&scope.row.editing === 'arrive'" v-model.trim="scope.row[item.prop]" ></el-input>
                                <span v-else>{{scope.row[item.prop]}}</span>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination small layout="prev, pager, next" @current-change="pageChange" :total="tableDataListsLenth"></el-pagination>
                </div>
            </template>
            <span class="bill-details">费用明细</span>
            <template class="table-head">
                <el-table v-loading="loading2" :data="tableDataLists2" border height="250" ref="dragTable">
                    <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in costTableDataItems" :key="index"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination small layout="prev, pager, next" @current-change="pageChange2" :total="tableDataLists2Lenth"></el-pagination>
                </div>
            </template>
        </div>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import { getUploadLists, getCostDetails, getFeeDetails, saveDetails, confirm, getTasks, getTaskRecall } from '../../../api/cost.js';
import index from './config.js';
import { COST_BMS_TASK_STATUS } from '../../../utils/configuration';
import request from '@/utils/http';
import ElRow from './components/ElRow';
import common from '../../../common/common';
import { myXixins } from '../../../mixins/mixins';
import DeliverClass from '../../../common/DeliverClass';
import { mapGetters } from 'vuex';
const { initSessionData } = common;
const TOTAL_TEN = '10'; // 任务数量
export default {
    name: 'deliver',
    components: { Paper, ElRow },
    mixins: [myXixins],
    data() {
        return {
            index,
            isDisabled: true,
            isShow: true,
            isRecall: true,
            isConfirm: true,
            recallLoading: false,
            loading: false,
            loading2: false,
            arr: [],
            arrList: [],
            tableArray: [],
            tableDataItems: [],
            tableDataLists2: [],
            tableDataLists: [{ editing: 'arrive' }],
            fineObj: {},
            infoData: {},
            searchObj: { pageNo: 1, pageSize: 10 },
            searchObjList: { pageNo: 1, pageSize: 10 },
            tableDataLists2Lenth: 0,
            tableDataListsLenth: 0,
            currentPage: 1,
            ObjList: '',
            status: '',
            tasktype: '',
            businessTypeData: ''
        };
    },
    computed: {
        ...mapGetters(['visitedViews'])
    },
    methods: {
        inputChange(row) {
            if (row.supplierAmount) {
                row.hasValue = false;
            }
        },
        getData() {
            if (this.$route.query.hasOwnProperty('feeTaskCode') && this.$route.query.feeTaskCode !== null && this.$route.query.feeTaskCode !== '') {
                const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, feeTaskCode: this.$route.query.feeTaskCode };
                getTasks(params).then(res => {
                    if (res && res.code === '0') {
                        this.fineObj = res.data.list[0];
                        this.infoData = new DeliverClass(this.fineObj);
                        const { BID_BUSINESS_TYPE, SRM_BMS_TASK_TYPE, SYS_BMS_TASK_STATUS } = window.sessionStorage;
                        this.infoData.businessType = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[this.infoData.businessType] : this.infoData.businessType;
                        this.infoData.feeTaskType = SRM_BMS_TASK_TYPE ? JSON.parse(SRM_BMS_TASK_TYPE)[this.infoData.feeTaskType] : this.infoData.feeTaskType;
                        this.status = SYS_BMS_TASK_STATUS ? JSON.parse(SYS_BMS_TASK_STATUS)[this.fineObj.status] : this.fineObj.status;
                        this.isConfirm = this.fineObj.status !== COST_BMS_TASK_STATUS.TO_BECON_FIRMED;
                        if (this.fineObj.status === COST_BMS_TASK_STATUS.COST_CONSISTENT || this.fineObj.status === COST_BMS_TASK_STATUS.COST_DIFFERENCE) {
                            this.isRecall = false;
                        } else {
                            this.isRecall = true;
                        }
                    }
                    this.load();
                }).catch(() => {});
            } else {
                this.fineObj = {};
                this.routeJump();
            }
        },
        load() {
            if (this.$route.query.hasOwnProperty('feeTaskCode') && this.$route.query.feeTaskCode !== null) {
                var temp = { feeTaskCode: this.$route.query.feeTaskCode, pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize };
                this.loading = true;
                this.currentPage = this.searchObj.pageNo;
                getCostDetails(temp).then(res => {
                    if (res && res.code === '0') {
                        this.arr = res.data.list.map(item => item.supplierAmount);
                        this.tableDataLists = res.data.list.map(item => {
                            item.hasValue = false;
                            item.editing = 'arrive';
                            item.editing = this.fineObj.status === COST_BMS_TASK_STATUS.TO_BECON_FIRMED ? 'arrive' : '';
                            return item;
                        });
                        this.tableDataListsLenth = res.data.totalCount;
                        this.totalTasks = res.data.totalPage;
                    }
                    this.loading = false;
                });
            } else {
                this.loading = false;
                this.arr = [];
                this.routeJump();
            }
        },
        saveDetails() {
            var datas = [];
            for (var i = 0; i < this.tableDataLists.length; i++) {
                if (this.tableDataLists[i].supplierAmount === '' || this.tableDataLists[i].supplierAmount === undefined) {
                    return this.$message.warning('确认费用金额不能为空');
                }
                if (Number(this.tableDataLists[i].supplierAmount) !== this.tableDataLists[i].amount &&
                (this.tableDataLists[i].supplierMsg === undefined || this.tableDataLists[i].supplierMsg === '')) {
                    this.$message.warning('确认金额不一致，请备注原因');
                    return;
                }
                var data = { jobId: this.tableDataLists[i].jobId,
                    supplierAmount: this.tableDataLists[i].supplierAmount,
                    supplierMsg: this.tableDataLists[i].supplierMsg,
                    feeTaskCode: this.$route.query.feeTaskCode };
                datas.push(data);
            }
            saveDetails(datas).then(res => {
                if (res.code === '0') {
                    this.fineObj.status = res.data.status;
                    this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                    this.arrList = this.tableDataLists.map(item => item.supplierAmount);
                    this.arr = this.arrList;
                    this.$message.success('保存成功');
                }
                this.getData();
            });
        },
        saveAllDetails() {
            if (this.totalTasks > TOTAL_TEN) {
                return this.$message.warning('此按钮只适用10条内的明细数据');
            } else {
                this.batchConfirmation();
            }
        },
        batchConfirmation() {
            var datas = [];
            for (var i = 0; i < this.tableDataLists.length; i++) {
                var data = {
                    feeTaskCode: this.$route.query.feeTaskCode,
                    jobId: this.tableDataLists[i].jobId,
                    supplierAmount: this.tableDataLists[i].supplierAmount || this.tableDataLists[i].amount,
                    supplierMsg: this.tableDataLists[i].supplierMsg
                };
                datas.push(data);
            }
            saveDetails(datas).then(res => {
                if (res.code === '0') {
                    this.fineObj.status = res.data.status;
                    this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                    for (var i = 0; i < this.tableDataLists.length; i++) {
                        if (this.fineObj.status && this.fineObj.status === COST_BMS_TASK_STATUS.TO_BECON_FIRMED) {
                            this.$set(this.tableDataLists[i], 'editing', 'arrive');
                            this.tableDataLists[i].hasValue = true;
                        }
                    }
                    this.arrList = this.tableDataLists.map(item => item.supplierAmount);
                    this.arr = this.arrList;
                    this.$message.success('批量确认成功');
                }
                this.getData();
            });
        },
        submitUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            getUploadLists(formData)
                .then(res => {
                    if (res && res.code === '0') {
                        this.$message.success('导入成功');
                        this.load();
                    } else {
                        this.$message.warning('导入失败');
                    }
                })
                .catch(() => {});
        },
        exportFeeDetail() {
            // 任务类型为手工预估 直接传5
            // 业务类型为3 4 10并且任务类型为计费数据任务 类型传1
            // 1 是运配  2 装卸  3 仓储  4 快递  5  手工预估
            // {1: "仓储", 2: "装卸", 3: "运输", 4: "配送", 5: "快递", 6: "其他业务", 7: "资产转卖", 10: "宅配", 11: "设备类"}
            if ((this.fineObj.businessType === '3' || this.fineObj.businessType === '4' || this.fineObj.businessType === '10') && (this.fineObj.feeTaskType === '10')) {
                this.tasktype = '1';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '2')) {
                this.tasktype = '2';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '1')) {
                this.tasktype = '3';
            } else if ((this.fineObj.feeTaskType === '10') && (this.fineObj.businessType === '5')) {
                this.tasktype = '4';
            } else if (this.fineObj.feeTaskType === '20') {
                this.tasktype = '5';
            }
            var temp = {
                taskCode: this.fineObj.feeTaskCode,
                tasktype: this.tasktype
            };
            request({
                url: '/api-bms-web/feeTask/exportFeeDetail',
                method: 'get',
                params: temp,
                responseType: 'arraybuffer'
            }).then(res => {
                const blob = new Blob([res], {
                    type: 'application/x-excel;charset=UTF-8'
                });
                const objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = objectUrl;
                a.download = '费用明细.xlsx';
                a.click();
            });
        },
        confirm() {
            var data = { id: this.$route.query.jobid, feeTaskCode: this.$route.query.feeTaskCode };
            this.tableArray = this.tableDataLists.every(item => {
                return item.supplierAmount !== undefined && item.supplierAmount !== '';
            });
            if (!this.tableArray) {
                return this.$message.warning('确认费用金额不能为空');
            } else {
                for (let i = 0; i < this.tableDataLists.length; i++) {
                    if (Number(this.tableDataLists[i].supplierAmount) !== this.tableDataLists[i].amount &&
                (this.tableDataLists[i].supplierMsg === undefined || this.tableDataLists[i].supplierMsg === '')) {
                        return this.$message.warning('确认金额不一致，请备注原因');
                    }
                }
            }
            if (this.tableDataLists.map(item => item.supplierAmount).toString() === this.arr.toString()) {
                confirm(data).then(res => {
                    if (res.code === '0') {
                        this.fineObj.status = res.data.status;
                        this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                        for (let index = 0; index < this.tableDataLists.length; index++) {
                            this.tableDataLists[index].editing = '';
                        }
                    }
                    this.getData();
                });
            } else {
                return this.$message.warning('数据已更改，请先保存之后再提交');
            }
        },
        handleCurrentChange(val) {
            if (val) {
                if (this.fineObj.feeTaskType === '20') {
                    this.businessTypeData = '100';
                } else {
                    this.businessTypeData = this.fineObj.businessType;
                }
                this.ObjList = { jobId: val.jobId, businessType: this.businessTypeData };
                this.getFeeDetails(this.ObjList.jobId, this.ObjList.businessType);
            }
        },
        getFeeDetails(jobId, businessType) {
            var temp = {
                jobId: jobId,
                pageNo: this.searchObjList.pageNo,
                pageSize: this.searchObjList.pageSize,
                businessType: businessType
            };
            this.currentPage = this.searchObjList.pageNo;
            this.loading2 = true;
            getFeeDetails(temp).then(res => {
                this.loading2 = false;
                this.tableDataLists2 = res.data.list;
                this.tableDataLists2Lenth = res.data.totalCount;
            });
        },
        pageChange(page) {
            this.searchObj.pageNo = page;
            this.load();
        },
        pageChange2(page) {
            this.searchObjList.pageNo = page;
            this.getFeeDetails(this.ObjList.jobId, this.ObjList.businessType);
        },
        async withdraw() {
            this.recallLoading = true;
            await getTaskRecall(this.$route.query.feeTaskCode).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('撤回成功');
                }
                this.recallLoading = false;
                this.getData();
            }).catch(() => { this.recallLoading = false; });
        }
    },
    mounted() {
        initSessionData(['SYS_BMS_TASK_STATUS', 'SRM_BMS_TASK_TYPE', 'BID_BUSINESS_TYPE']);
        this.getData();
    },
    activated() {
        this.getData();
        this.tableDataLists2 = [];
        this.tableDataLists2Lenth = 0;
        this.loading2 = false;
        this.infoData.supplierComfirmAmount = 0;
    },
    created() {
        this.infoData = index.infoData;
        this.tableDataItems = index.tableDataItems;
        this.costTableDataItems = index.costTableDataItems;
    }
};
</script>

<style lang="less">
@import "../../../styles/common.less";
@import "./deliver.less";
</style>
